export default function(frames) {
  return { x: getMinX(frames), y: getMinY(frames) }
}

function getMinX(frames) {
  return frames.reduce((min, p) => (p.setPosition.x < min ? p.setPosition.x : min), frames[0].setPosition.x)
}

function getMinY(frames) {
  return frames.reduce((min, p) => (p.setPosition.y < min ? p.setPosition.y : min), frames[0].setPosition.y)
}



// WEBPACK FOOTER //
// ./src/utils/findSetPosition.js